// @flow
import React, {useState, useRef} from 'react';
import {Popover, Overlay} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import './style.css';
import Card from 'react-bootstrap/Card';
import {observer} from 'mobx-react-lite';
import {useStore} from '../../store';
import {CardWrapper, Title, Text, PopoverDiv} from './style';
import stringToURLSlug from '../../utils/helper';
import UpgradeModal from '../UpgradeModal';
import {amplitude} from '../../utils/Amplitude';
import {ActiveSmallBtn, DefaultSmallBtn} from '../FollowButtons';

type Props = {
  expert: {
    id: number,
    name: string,
    thumbnail: string,
    is_following: boolean,
    follow: [
      {
        id: number,
      },
    ],
    organization: {
      name: string,
    },
    specialty: {
      name: string,
    },
    isExtraDataLoaded: boolean,
  },
  type: number | null,
  onFollow: Function,
  storeName: string,
};
const ExpertTile = observer(({expert, type, onFollow, storeName}: Props) => {
  const location = useHistory();
  const store = useStore();
  const {fetchItem} = store[storeName];
  const {followExpert, unFollowExpert} = store.mediaStore;
  const [popoverOpen, togglePopover] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const timer = useRef(null);
  const {account} = store.accountStore;
  const [isShowFollowUpgradeModal, setShowFollowUpgradeModal] = useState(false);
  const {resetExpert} = store.expertStore;

  const onClickTile = () => {
    resetExpert();
    const slug = stringToURLSlug(expert.name);
    location.push(`/experts/${expert.id}/${slug}`);
  };

  /* istanbul ignore next */
  const onHover = async event => {
    setTarget(event.currentTarget);
    if (window.outerWidth > 890) {
      timer.current = setTimeout(() => {
        togglePopover(true);
      }, 500);
    }
    if (!expert?.isExtraDataLoaded) {
      await fetchItem('expert', type, expert?.id);
    }
  };

  /* istanbul ignore next */
  const onHoverLeave = () => {
    togglePopover(false);
    clearTimeout(timer.current);
  };

  const follow = selectedItem => {
    const user = localStorage.getItem('user');
    if (user) {
      if (selectedItem.is_following) {
        unFollowExpert(selectedItem, type);
        const eventProperties = {
          type: 'expert',
          source: 'expert tile',
          name: `${selectedItem.name}`,
        };
        amplitude.getInstance().logEvent('unfollow', eventProperties);
      } else {
        followExpert(selectedItem, type);
        const eventProperties = {
          type: 'expert',
          source: 'expert tile',
          name: `${selectedItem.name}`,
        };
        amplitude.getInstance().logEvent('follow', eventProperties);
      }
    } else {
      location.push('/login');
    }
  };

  const gotoExpertDetail = () => {
    resetExpert();
    const slug = expert.name.split(',', 1);
    location.push(`/experts/${expert.id}/${stringToURLSlug(slug[0])}`);
  };

  return (
    <>
      <UpgradeModal
        access="bookmark"
        isShow={isShowFollowUpgradeModal}
        onHideModal={() => setShowFollowUpgradeModal(false)}
      />
      <CardWrapper onMouseLeave={onHoverLeave}>
        <Card className="mx-auto my-3" onMouseEnter={onHover} onClick={onClickTile}>
          <Card.Img src={expert.thumbnail} alt={expert.name} />
          <Card.Body>
            <Title>{expert.name}</Title>
            <Text>
              {expert?.specialty?.name}
              {expert?.specialty?.name ? <br /> : null}
              {expert?.organization?.name}
            </Text>
          </Card.Body>
        </Card>
        <Overlay show={popoverOpen} target={target} container={ref.current}>
          <Popover id="popover-basic" className="a_spcialist-popover">
            <PopoverDiv>
              <Popover.Content>
                <Card>
                  <Card.Img src={expert.thumbnail} alt={expert.name} onClick={() => gotoExpertDetail()} />
                  <Card.Body>
                    <Title onClick={() => gotoExpertDetail()}>{expert.name}</Title>
                    <Text>{expert?.specialty?.name}</Text>
                    <Text>{expert?.organization?.name}</Text>
                    {expert?.isExtraDataLoaded && (
                      <div className="d-flex justify-content-center px-3 align-items-center pt-2">
                        {account?.subscription?.name?.includes('Basic') ? (
                          <DefaultSmallBtn className="a_follow" onClick={() => setShowFollowUpgradeModal(true)}>
                            <i className="fas fa-plus mr-2" />
                            Follow
                          </DefaultSmallBtn>
                        ) : null}
                        {!account?.subscription?.name?.includes('Basic') && expert.follow?.length ? (
                          <ActiveSmallBtn
                            className="a_followed"
                            onClick={() => (onFollow ? onFollow(expert) : follow(expert))}
                          >
                            <span className="following">
                              <i className="fas fa-check mr-2" />
                              Following
                            </span>
                            <span className="unfollow">
                              <i className="fas fa-times mr-2" />
                              Unfollow
                            </span>
                          </ActiveSmallBtn>
                        ) : (
                          !account?.subscription?.name?.includes('Basic') && (
                            <DefaultSmallBtn
                              className="a_follow"
                              onClick={() => (onFollow ? onFollow(expert) : follow(expert))}
                            >
                              <i className="fas fa-plus mr-2" />
                              Follow
                            </DefaultSmallBtn>
                          )
                        )}
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Popover.Content>
            </PopoverDiv>
          </Popover>
        </Overlay>
      </CardWrapper>
    </>
  );
});
export default ExpertTile;
